export default __webpack_public_path__ + "static/meshery-most-popular-lfx-internship-7cdcd81985db5ad1b50fb0216a1f811a.webp";